<template>
  <v-chip
    v-if="cpuExecutionTime && cpuExecutionTime != 'N/A'"
    color="black"
    outlined
    label
    class="ml-3"
    style="
      text-transform: capitalize;
      height: 36px;
      background-color: white !important;
    "
  >
    CPU Exec. Time: {{ cpuExecutionTime }}
  </v-chip>
</template>

<script>
import { formatMetricValue } from '../../services/metricService';

export default {
  props: {
    hyperionNodes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    cpuExecutionTime() {
      // Find the first Hyperion node with CPU Execution Time metric enabled
      for (let node of this.hyperionNodes) {
        let alert = node.alerts.filter(
          (alert) => alert.metric === 'Producer/CPU_Execution_Time'
        )[0];

        if (alert) {
          let value = this.$store.state.metrics.metric[alert.id];
          if (value) {
            return formatMetricValue('Producer', 'CPU_Execution_Time', value);
          }
        }
      }
      return 'N/A';
    },
  },
};
</script>
